import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';
import VerifyCodeRequest from '../../commons/mappings/verifyCodeRequest.mapping';

class VerifyCodeProvider {

    constructor() {
        this.paths              = URLConfiguration.paths;
        this.verifyCodeRequest  = new VerifyCodeRequest();
        this.apiProvider        = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
    }

    verificarCodigo = async (datosVerificacion) => {
        const headers   = HeadersMapping.getHeaderService();
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.otp.verificarCodigo, {});
        const request   = this.verifyCodeRequest.getRequestVerifyCode(datosVerificacion);
        let response    = null;
        try {
            response = await this.apiProvider.post(pathNew, request, { headers });
        } catch (error) {
            console.log(error);
        }
        return response
    }

}

export default VerifyCodeProvider;